export function getStateFromUrl(urlState: any, skipUndefined: boolean = true): any {
    let stateFromUrl: any = {}

    for (const [name, value] of Object.entries(urlState)) {
        if (skipUndefined === true && value === undefined){
            continue
        }

        stateFromUrl[name] = {
            timeStamp: Date.now(),
            value: value
        }
    } 

    return stateFromUrl
} 